export default __webpack_public_path__ + "static/media/Facebook_Icon.2da26ca8.svg";